var _defs, _circle, _path, _path2, _path3, _circle2, _circle3, _circle4, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowerTubSpoutHandShower({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st0, .st1, .st2 {\n        stroke-linecap: round;\n      }\n\n      .st0, .st2 {\n        stroke: #5e6368;\n        stroke-linejoin: round;\n      }\n\n      .st1 {\n        stroke: #74aa4e;\n        stroke-dasharray: 1.14 1.89;\n        stroke-miterlimit: 10;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #5e6368;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 49.1,
    cy: 52,
    r: 4.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.1,54.1c-1.4,0-3.6.8-5.3,1.3-.3.1-.4-.2-.2-.4,4.3-3.9,4.3-4.3,5.3-9.1.1-.3.4-.3.5,0,1.1,4.8,1.1,5.3,5.3,9.1.2.2,0,.5-.2.4-1.8-.5-4-1.3-5.4-1.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49,76.8v9M46.7,75.5v10.1M51.3,75.5v10.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.6,73c-.4-.9-.6-1.8-.8-2.7-.1-.9-.7-1.9-2.8-1.9s-2.7,1-2.8,1.9-.3,1.9-.8,2.7l-.2.4h7.4c.1,0,.1-.2,0-.4Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 67.9,
    cy: 49.5,
    r: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 67.9,
    cy: 47.4,
    r: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 67.9,
    cy: 45.3,
    r: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.39,57.34v-13.4h2.1v13.4h-2.1ZM65,49.5v-3.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.4,57.5c0,3.7,3.9,13.5-2.1,13.5-7.1,0-1.6-17.1-1.6-36.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.3,66.4h1.4M49,66.4v.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,77.1h-5.5c-3.8,0-8,1.7-11.4,4.7l-4.2,3.7M55.4,77.1h5.5c3.8,0,8,1.7,11.4,4.7l4.2,3.7M23.5,10.5h51.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerTubSpoutHandShower);
export default __webpack_public_path__ + "static/media/shower-tub-spout-hand-shower.847b5591e853264830bc9e6ee239fbc3.svg";
export { ForwardRef as ReactComponent };